import { useQuery } from '@tanstack/react-query'
import { fetchMe, isAdminOrgType } from './auth'
import { USE_REAL_API } from './api'
import { useAuthStore } from '../store/auth'

// Shared /auth/me reader. Mock mode: never seller staff, every capability on.
export function useMe() {
  // Keyed by the access token (same as useRealAuthGuard): a fixed key would
  // reuse the previous account's capabilities for staleTime after a
  // same-tab logout/login, e.g. showing owner-only controls to Staff.
  const accessToken = useAuthStore((s) => s.accessToken)
  const q = useQuery({
    queryKey: ['me', accessToken],
    queryFn: fetchMe,
    enabled: USE_REAL_API && Boolean(accessToken),
    staleTime: 5 * 60 * 1000,
  })
  const m = q.data?.active_membership
  const isSellerStaff = USE_REAL_API && m?.org_type === 'BO2' && m?.tier === 'admin'
  const isPexifyStaff = !USE_REAL_API || isAdminOrgType(m?.org_type)
  const pricesHidden = USE_REAL_API && m?.prices_hidden === true
  const hasCapability = (cap: string) =>
    !USE_REAL_API || Boolean(q.data?.capabilities.includes(cap))
  return { me: q.data, isSellerStaff, isPexifyStaff, pricesHidden, hasCapability }
}
